<ng-container [formGroup]="form">


  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true}" (click)="toggleOpen()">
        <span class="margin-right">Formations</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell large-2 medium-2 small-2 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      FORMATION
    </div>
    <div class="cell large-1 medium-1 small-1 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      TOP
    </div>
    <div class="cell large-1 medium-1 small-1 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      BASE
    </div>
    <div class="cell large-2 medium-2 small-2 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      SHOWS OF OIL/GAS/FRESH WATER/BRINE; indicate depth or interval
    </div>
    <div class="cell large-2 medium-2 small-2 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      PRODUCING FORMATION?
    </div>
    <div class="cell large-2 medium-2 small-2 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      METHOD OBTAINED
    </div>
    <div class="cell large-2 medium-2 small-2 bold padding-right padding-left text-align-center border-one-pixel-solid-gray">
      REMARKS
    </div>
    @for (item of countedItems; track item) {
      <div class="cell large-2 medium-2 small-2 padding-right padding-left padding-top border-one-pixel-solid-gray">
        <select [formControlName]="getFieldName('selectedFormation', item, false)" (ngModelChange)="formationChanged(item, $event)">
          @for (formation of formations; track formation) {
            <option [value]="formation.code">{{formation.definition}}</option>
          }
        </select>
        @if (fieldHasNotes(getFieldName('selectedFormation', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('selectedFormation', item, true)" [notes]="getFilteredNotes(getFieldName('selectedFormation', index, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell large-1 medium-1 small-1 padding-right padding-left padding-top border-one-pixel-solid-gray">
        <input type="number" [formControlName]="getFieldName('top', item, false)" />
        @if (fieldHasNotes(getFieldName('top', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('top', item, true)" [notes]="getFilteredNotes(getFieldName('top', item, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell large-1 medium-1 small-1 padding-right padding-left padding-top border-one-pixel-solid-gray">
        <input type="number" [formControlName]="getFieldName('base', item, false)" />
        @if (fieldHasNotes(getFieldName('base', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('base', item, true)" [notes]="getFilteredNotes(getFieldName('base', item, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell large-2 medium-2 small-2 padding-right padding-left padding-top padding-top border-one-pixel-solid-gray">
        <input type="text" [formControlName]="getFieldName('showsOf', item, false)" />
        @if (fieldHasNotes(getFieldName('showsOf', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('showsOf', item, true)" [notes]="getFilteredNotes(getFieldName('showsOf', item, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell large-2 medium-2 small-2 padding-right padding-left padding-top text-align-center border-one-pixel-solid-gray">
        <div class="checkbox">
          <input class="show-for-sr no-margin vertical-align-middle" [id]="getFieldName('producingFormation', item, false)" type="checkbox" [formControlName]="getFieldName('producingFormation', item, false)" />
          <label [for]="getFieldName('producingFormation', item, false)" class="minor-margin-right display-inline-block">
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Producing
          </label>
        </div>
        @if (fieldHasNotes(getFieldName('producingFormation', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('producingFormation', item, true)" [notes]="getFilteredNotes(getFieldName('producingFormation', index, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell large-2 medium-2 small-2 padding-right padding-left padding-top border-one-pixel-solid-gray">
        <select [formControlName]="getFieldName('methodObtained', item, false)">
          @for (method of methodTypes; track method) {
            <option [value]="method.Code">{{method.Definition}}</option>
          }
        </select>
        @if (fieldHasNotes(getFieldName('methodObtained', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('methodObtained', item, true)" [notes]="getFilteredNotes(getFieldName('methodObtained', index, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell large-2 medium-2 small-2 padding-right padding-left padding-top border-one-pixel-solid-gray">
        <input type="text" [formControlName]="getFieldName('remarks', item, false)" />
        @if (fieldHasNotes(getFieldName('remarks', item, true)) || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="getFieldName('remarks', item, true)" [notes]="getFilteredNotes(getFieldName('remarks', item, true))" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
    }
  </div>
</ng-container>

